export const ribbonAddressBookLabel = "ZNjgRb";
export const ribbonAddressBookTooltip = "k7sCs";
export default {ribbonAddressBookLabel,ribbonAddressBookTooltip};